__webpack_require__.p = "https://beta.na.headphones.whs.amazon.dev/";